import ArrowLeftOnRectangle from "./svg/ArrowLeftOnRectangle"
import ArrowRightOnRectangle from "./svg/ArrowRightOnRectangle"

export function BeRightBack({
  className,
  callBack,
  isFullscreen = false,
}: {
  className: string
  callBack: () => void
  isFullscreen: boolean
}) {

  return (
    <>
      {isFullscreen ? (
        <ArrowLeftOnRectangle
          onClick={() => {
            callBack()
          }}
          className={className}
        />
      ) : (
        <ArrowRightOnRectangle
          onClick={() => {
            callBack()
          }}
          className={`w-6 h-6`}
        />
      )}
    </>
  )
}
